var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-page-header',{staticClass:"page-header",attrs:{"content":_vm.title},on:{"back":_vm.goBack}}),_vm._v(" "),_c('div',{staticClass:"content"},_vm._l((_vm.results),function(item){return _c('p',[_vm._v(_vm._s(item))])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b20b1f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceResult.vue
// module id = null
// module chunks = 